export default {"src":"/_next/static/media/not-found-cactus-confused.896a5add.svg","height":274,"width":185,"blurWidth":0,"blurHeight":0};